import React from "react";
import BackButton from "@components/backButton";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import CreateProductForm from "../form/Main";

const CreateNewProduct = () => {
  const { state } = useLocation();
  const { storeId } = useParams();
  const navigate = useNavigate();
  return (
    <>
      <BackButton onClick={() => navigate(-1)} />
      <CreateProductForm data={state} />
    </>
  );
};

export default CreateNewProduct;
